<div class="star-rating-container">
  <div class="stars" [attr.data-testid]="'star-rating-' + (id() || '')">
    @for (star of stars; track star) {
      <span class="star" [class.selected]="isSelected(star)" (click)="onStarClick(star)" [attr.data-testid]="'star-' + star">
        <mat-icon [ngClass]="'star-rating-size-' + size()">{{ isSelected(star) ? "star" : "star_border" }}</mat-icon>
      </span>
    }
  </div>
</div>
